import { Filter } from "iconoir-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { PROPOSAL_TYPE, WORK_STATUS, submissionMenu } from "../utils/constants";
import { Spin, message } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import { Button, useTheme } from "@mui/material";
import queryString from "query-string";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { inject, observer } from "mobx-react";
import UnreadText from "../components/common/UnreadText";
import {
  findCreater,
  findHandler,
  getNameInCapitalize,
  TextWrap,
} from "../utils/common";
import { EmptyText } from "../components/common/CellText";
import moment from "moment";
import { DATE_FORMAT_SLASH } from "../utils/constants";
import EmptyData from "../components/image/EmptyData";
import SkeletonTable from "../components/Skeleton/SkeletonTable";
import SearchAdvance from "../modules/Proposal/SearchAdvanceModal";
import { MdManageAccounts, MdOutlineTimer } from "react-icons/md";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import {
  AiFillCaretRight,
  AiFillStar,
  AiOutlineCheckCircle,
  AiOutlineStar,
} from "react-icons/ai";
import { FcOk } from "react-icons/fc";
import ProposalTable from "../modules/Proposal/ProposalTable";
import CreateModal from "../modules/Proposal/CreateModal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="pt-2 ">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ProposalPage = ({ proposalStore, proposalTypeStore }) => {
  const { proposalList, totalCountProposal } = proposalStore;

  const location = useLocation();
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: "index",
  });
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    keyword: undefined,
    proposal_status: undefined,
    type: undefined,
    proposal_permission: undefined,
  });
  const [isRefreshPage, setIsRefreshPage] = useState(true);
  const [loading, setLoading] = useState(true);

  const [openSearchAdvance, setOpenSearchAdvance] = useState(false);

  const [openContent, setOpenContent] = useState(false);
  const [openHandler, setOpenHandler] = useState(false);
  const [openCre, setOpenCre] = useState(false);

  const [proposalTypes, setProposalTypes] = useState([]);
  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([]);
  // sử lý thêm loại khác vào submissionMenu
  useEffect(() => {
    (async () => {
      proposalStore.clearFilterProposal();
      const response = await proposalTypeStore.getProposalTypes();
      setProposalTypes(response.data);
      const newProposalTypes = [
        {
          id_group: "3",
          name_group: "Hành chính - Khác",
          child: response.data
            .filter((item) => item.id.includes("OTHER_"))
            .map((item) => ({
              id_child: item.id,
              name_child: item.name,
            })),
        },
      ];
      const updatedSubmissionMenu = submissionMenu.concat(newProposalTypes);
      setArrSubmissionMenu(updatedSubmissionMenu);
    })();
  }, []);

  /** Hiển thị danh sách loại phiếu trình (Lọc theo loại phiếu trình) */
  const showSubmissionMenu = useMemo(() => {
    return arrSubmissionMenu?.length >= 3 ? (
      arrSubmissionMenu?.map((unit, index) => {
        return (
          <optgroup
            style={{ color: "#2c65ac", fontWeight: "500" }}
            label={unit.name_group}
            key={unit.id_group}
          >
            {unit?.child.map((child) => {
              return (
                <option
                  style={{
                    marginLeft: "10px",
                    color: "#000000DE",
                    fontWeight: "400",
                  }}
                  value={child.id_child}
                  key={child.id_child}
                >
                  {child.name_child}
                </option>
              );
            })}
          </optgroup>
        );
      })
    ) : (
      <></>
    );
  }, [arrSubmissionMenu]);
  //Lấy danh sách các cấp duyệt
  const [approvalTemplates, setApprovalTemplates] = useState([]);

  const getApprovalTemplates = async () => {
    try {
      const response = await proposalStore.getApprovalTemplateListV2();
      setApprovalTemplates(response.data);
    } catch (err) {
      console.log(err);
      message.error(err?.vi || "Đã có lỗi xảy ra!");
    }
  };
  useEffect(() => {
    (async () => {
      try {
        await getApprovalTemplates();
      } catch (err) {
        console.log(err);
        message.error(err?.vi || "Đã có lỗi xảy ra!");
      }
    })();
  }, []);

  const getProposals = async (params) => {
    try {
      await proposalStore.getProposals(params);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  useEffect(() => {
    const params = {
      page: queryStringParse?.page || filter.page,
      size: queryStringParse?.size || filter.size,
      keyword: queryStringParse?.keyword || filter.keyword,
      proposal_status:
        queryStringParse?.proposal_status || filter.proposal_status,
      type: queryStringParse?.type || filter.type,
      proposal_permission:
        queryStringParse?.proposal_permission || filter.proposal_permission,
    };

    setFilter(params);
    (async () => {
      setLoading(true);
      proposalStore.clearProposalList();
      await getProposals(params);
      setLoading(false);
      setIsRefreshPage(false);
    })();
  }, []);

  useEffect(() => {
    if (isRefreshPage) return;
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    });
    navigate({ pathname: "/proposal", search: queryStringStringify });
    (async () => {
      try {
        setLoading(true);
        proposalStore.clearProposalList();
        await getProposals(filter);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  function createData(
    title,
    calories,
    fat,
    carbs,
    important,
    status,
    has_subwork,
    code,
    parent_id
  ) {
    return {
      title,
      calories,
      fat,
      carbs,
      important,
      status,
      has_subwork,
      code,
      parent_id,
    };
  }
  const theme = useTheme();
  const formatData = (dataList) => {
    return dataList.map((record) =>
      createData(
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            lineHeight: "25px",
            WebkitLineClamp: "2",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            maxHeight: "50px",
            padding: "4px",
            color: theme.color.primary,
          }}
        >
          {record?.title}
        </div>,
        <UnreadText
          text={
            record?.assignees &&
            getNameInCapitalize(
              findHandler(record?.assignees)[0].name_uppercase
            )
          }
          isUnread={checkUnread(record)}
          width={"100%"}
        />,
        <UnreadText
          text={
            <div className="flex gap-2">
              <MdManageAccounts size={14} color={theme.color.primary} />
              <div style={{ fontSize: 12 }}>
                {record?.assignees &&
                  findCreater(record?.assignees).map((item) =>
                    getNameInCapitalize(item.name_uppercase)
                  )}
              </div>
              <AiFillCaretRight
                style={{
                  margin: "3px 5px 0 5px",
                  minWidth: "10px",
                  color: theme.color.primary,
                }}
                size={14}
              />
            </div>
          }
          isUnread={checkUnread(record)}
          width={"100%"}
        />,
        <UnreadText
          text={
            <div className="flex gap-2 items-center justify-between">
              <MdOutlineTimer color={theme.color.primary} size={14} />
              <div style={{ fontSize: 12 }}>
                {record?.due_date ? (
                  moment(record?.due_date).format(DATE_FORMAT_SLASH)
                ) : (
                  <TextWrap>
                    <EmptyText>Không rõ</EmptyText>
                  </TextWrap>
                )}
              </div>
            </div>
          }
          isUnread={checkUnread(record)}
          width={"100%"}
        />,
        record?.important === true ? (
          <AiFillStar size={14} color="rgb(255,199,0)" />
        ) : (
          <AiOutlineStar size={14} />
        ),
        record?.status === WORK_STATUS.COMPLETE ? (
          <FcOk size={14} />
        ) : (
          <AiOutlineCheckCircle size={14} color="#a2a2a2" />
        ),
        record?.import,
        record?.code,
        record?.parent_id
      )
    );
  };
  const checkUnread = (record) => record.is_read !== true;
  const rows = formatData(proposalList);
  const [hasMore, setHasMore] = useState(false);
  const [value, setValue] = useState(0);
  const [searchParams] = useSearchParams();
  const permissionParam = searchParams.get("proposal_permission");
  useEffect(() => {
    if (permissionParam == "CREATE") {
      setValue(1);
    } else {
      setValue(0);
    }
  }, []);
  // Khi thay đổi tab thì set lại hasMore, clear filter rồi set lại filter
  const handleChange = async (event, newValue) => {
    setValue(newValue);
    let permission = "";
    if (newValue === 0) {
      permission = undefined;
    } else if (newValue === 1) {
      permission = "CREATE";
    }
    setHasMore(true);
    proposalStore.clearProposalList();
    setFilter({ ...filter, ...{ proposal_permission: permission } });
    proposalStore.clearProposalStore();
  };
  //  fetchMoreData cho phép được cuộn trang khi hasMore = true
  const fetchMoreData = async () => {
    if (proposalList.length >= totalCountProposal) {
      setHasMore(false);
      return;
    }

    const pageSize = 10;
    proposalStore.setQueryParams({
      page: proposalStore.defaultQueryParams.page + 1,
      size: pageSize,
      proposal_permission: filter.proposal_permission,
    });

    try {
      await getProposals({
        ...filter,
        page: proposalStore.defaultQueryParams.page,
        size: pageSize,
        proposal_permission:
          proposalStore.defaultQueryParams.proposal_permission,
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    proposalStore.clearProposalStore();
  }, []);

  useEffect(() => {
    if (proposalList.length <= totalCountProposal) {
      setHasMore(true);
      return;
    }

    proposalStore.clearProposalStore();
  }, [proposalList]);
  // chuyển trang khác thì luôn được cuộn lên đầu trang
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: theme.background.base, minHeight: "850px" }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}
      >
        <div className="font-bold text-[28px] leading-[29px]  ">Hành chính</div>
        <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenSearchAdvance(true);
          }}
        >
          <Filter />
        </span>
      </div>
      <MainLayout initialValue={4}>
        <div className="pl-2 pr-2 pt-20">
          <Box className="" sx={{}}>
            <Box sx={{}}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Tất cả"
                  {...a11yProps(0)}
                />
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Đã gửi"
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
          </Box>
          <Button
            variant="contained"
            color="primary"
            className="mt-4 pr-6 normal-case"
            onClick={() => {
              setOpenCre(true);
              // message.warning('Tính năng tạm thời đang phát triển!')
            }}
          >
            Tạo mới hành chính
          </Button>
          {loading ? (
            <SkeletonTable />
          ) : proposalList?.length > 0 ? (
            <>
              <section className=" overflow-x-auto hideScrollbar work-table">
                <InfiniteScroll
                  dataLength={proposalList.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  style={{
                    scrollSnapStop: "always",
                  }}
                  loader={
                    <div
                      style={{
                        paddingTop: 20,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {proposalList.length > 10 ? (
                        <Spin tip="Đang tải..." />
                      ) : (
                        ""
                      )}
                    </div>
                  }
                >
                  <div className="mb-16">
                    {proposalList?.map((data, index) => (
                      <ProposalTable key={index} data={data} />
                    ))}
                  </div>
                </InfiniteScroll>
              </section>{" "}
            </>
          ) : (
            <EmptyData />
          )}
        </div>
        <SearchAdvance
          proposalStore={proposalStore}
          arrSubmissionMenu={arrSubmissionMenu}
          openSearchAdvance={openSearchAdvance}
          handleOpenSearchAdvance={() => {
            setOpenSearchAdvance(true);
          }}
          handleCloseSearchAdvance={() => {
            setOpenSearchAdvance(false);
          }}
          setFilter={setFilter}
          filter={filter}
        />
        <CreateModal
          approvalTemplates={approvalTemplates}
          showSubmissionMenu={showSubmissionMenu}
          proposalTypes={proposalTypes}
          setFilter={setFilter}
          params={filter}
          open={openCre}
          handleClose={() => {
            setOpenCre(false);
          }}
        />
      </MainLayout>
    </div>
  );
};

export default inject(
  "proposalStore",
  "proposalTypeStore"
)(observer(ProposalPage));
